export { default } from './LocationInfo';
